<template>
  <AnnouncementCard
    v-if="shouldShowBanner"
    localStorageKey="msp-pricing-card"
    @close="handleCloseButtonClick"
  >
    <div :class="$style.mainContent">
      <div :class="$style.leftSide">
        <HeadingMedium>
          JumpCloud Pricing for MSPs
        </HeadingMedium>
        <ParagraphBody :class="$style.paragraph">
          JumpCloud's MSP partners benefit from exclusive pricing and licensing options.
          Gain access to the Multi-Tenant Portal, sales and technical enablement,
          and dedicated implementation engineers.
        </ParagraphBody>
        <div>
          <ButtonGroup
            :class="[$style.ctaButtonsContainer, $style.buttonGroupStack]"
            :isFullWidth="false"
          >
            <ButtonSecondary
              data-test-id="MSPPricingCard__applyToJoinButton"
              text="Apply To Join"
              @click="handleApplyToJoinButtonClick"
            />
            <ButtonSecondary
              data-test-id="MSPPricingCard__talkToExpertButton"
              :href="`mailto:${$options.partnersEmailLink}`"
              text="Talk To An Expert"
              @click="handleTalkToExpertButtonClick"
            />
          </ButtonGroup>
        </div>
      </div>
      <div>
        <img
          alt="JumpCloud Pricing for MSPs"
          :class="[$style.image, $style.reducedResolution]"
          src="img/growth/msp_jc_graphic.png"
        >
      </div>
    </div>
  </AnnouncementCard>
</template>

<script>
import {
  ButtonGroup,
  ButtonSecondary,
  HeadingMedium,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import {
  eventLocations,
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import { get } from 'lodash';
import { mapGetters, mapState } from 'vuex';
import AnnouncementCard from 'client/components/AnnouncementCard/AnnouncementCard.vue';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import Util from 'client/util/Util';

const {
  description,
  location,
  section,
  text,
} = eventProperties;

const { pricingPage } = eventLocations;

const settingsModule = 'SettingsModule';
const organizationsCollection = 'OrganizationsCollection';

const partnersEmailLink = 'partners@jumpcloud.com';

export default {
  name: 'MSPPricingCard',

  components: {
    AnnouncementCard,
    ButtonGroup,
    ButtonSecondary,
    HeadingMedium,
    ParagraphBody,
  },

  EventHelper,
  Util,
  partnersEmailLink,

  computed: {
    ...mapState(settingsModule, ['orgId']),

    ...mapGetters(organizationsCollection, ['getItemDetails']),

    leadType() {
      return get(this.getItemDetails(this.orgId), 'leadType', '');
    },

    shouldShowBanner() {
      return this.leadType === 'MSP';
    },
  },

  methods: {
    handleApplyToJoinButtonClick() {
      this.$options.Util.openUrl('https://jumpcloud.com/partners/apply');
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'User clicked MSP banner "Apply To Join" button',
        [location]: pricingPage,
        [section]: 'MSP Pricing Banner',
        [text]: 'apply to join',
      });
    },

    handleCloseButtonClick() {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'User clicked MSP banner close button',
        [location]: pricingPage,
        [section]: 'MSP Pricing Banner',
      });
    },

    handleTalkToExpertButtonClick() {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'User clicked MSP banner "Talk To An Expert" button',
        [location]: pricingPage,
        [section]: 'MSP Pricing Banner',
        [text]: 'talk to an expert',
      });
    },
  },
};
</script>

<style module scoped>
@value (max-width-small) from '~css/breakpoints.css';

.cardContainer {
  display: flex;
}

.ctaButtonsContainer.ctaButtonsContainer {
  justify-content: flex-start;
}

.ctaButton {
  width: fit-content;
}

.closeButton {
  flex-shrink: 0;
}

.image {
  height: auto;
  width: 20rem;
}

.leftSide {
  display: flex;
  flex-direction: column;
}

@media (max-width: max-width-small) {
  .reducedResolution {
    display: none;
  }

  .buttonGroupStack.buttonGroupStack {
    grid-template-columns: none;
  }
}

.mainContent {
  display: flex;
  justify-content: space-between;
  text-align: left;
}

.paragraph {
  flex-grow: 1;
  flex-wrap: wrap;
  width: 90%;
}
</style>
